export enum VisibilityGuards {
  Permission = '@trustedshops/tswp-core-ui:PermissionVisbilityGuard'
}
